import { Typography, useTheme } from "@mui/material";
import React from "react";

const AVCTableRecordItems = ({ RecordNum }) => {
  const theme = useTheme();
  return (
    <Typography variant="caption" color={theme.palette.grey.gm}>
      تعداد کل رکوردها :
      <Typography variant="caption" color={theme.palette.text.primary}>
        {RecordNum}
      </Typography>
    </Typography>
  );
};

export default AVCTableRecordItems;
